document.querySelectorAll('.js-jadlospis-tabs').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
        const button = e.target.closest('.jadlospis__tab');
        if (!button) {
            return;
        }

        const block = tabs.closest('.jadlospis');
        if (!block) {
            return;
        }

        tabs.querySelectorAll('.jadlospis__tab').forEach(function (tab) {
            tab.classList.remove('is-active');
        });
        button.classList.add('is-active');

        block.querySelectorAll('.jadlospis__panel').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.id === button.dataset.target + '-panel');
        });
    });
});
